import { render, staticRenderFns } from "./AccountantPageHabibiya.vue?vue&type=template&id=570cc3a6"
import script from "./AccountantPageHabibiya.vue?vue&type=script&lang=js"
export * from "./AccountantPageHabibiya.vue?vue&type=script&lang=js"
import style0 from "./AccountantPageHabibiya.vue?vue&type=style&index=0&id=570cc3a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports